import React from 'react'
import {Upload , Modal } from 'antd'

export default class CiqaPicturesWall extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            fileList: [
            ],
          };
    }

     getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
  
      this.setState({
        previewImage: file.url || file.preview,
        previewVisible: true,
        previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
      });
    };

    handleChange(file) {
      this.props.handChange(file)
    } 

    beforeUpload(file) {
       
        return false;
    }

    render() {
        const { previewVisible, previewImage, previewTitle } = this.state;
        const fileList = this.props.fileList
        const uploadButton = (
          <div>
            {/* <PlusOutlined /> */}
            <div className="ant-upload-text">上传</div>
          </div>
        );
        return (
          <div className="clearfix">
            <Upload
              accept=".jpg,.png,.gif"
              listType="picture-card"
              fileList={fileList}
              onPreview={this.handlePreview}
              onChange={this.handleChange.bind(this)}
              beforeUpload={this.beforeUpload.bind(this)}
            >
              {fileList.length >= 1 ? null : uploadButton}
            </Upload>
            <Modal
              visible={previewVisible}
              title={previewTitle}
              footer={null}
              onCancel={this.handleCancel}
            >
              <img alt="example" style={{ width: '100%' }} src={previewImage} />
            </Modal>
          </div>
        );
    }
}